<template>
  <div v-if="groupType === 'open'" class="col-sm-12 col-lg-6 quick-search-bar my-1">
    <div v-for="filter in groupFilters" :key="filter.id">
      <component :is="filter.filterType" :filter="filter"></component>
    </div>
  </div>
  <div v-else class="col-sm-12 col-md">
    <b-dropdown pill variant="primary" class="my-1 filter-dropdown w-100">
      <template #button-content>
        {{ groupLabel }}
      </template>
      <li v-for="filter in groupFilters" :key="filter.id" role="menuitem" class="py-2 px-3">
        <component :is="filter.filterType" :filter="filter"></component>
      </li>
    </b-dropdown>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import VersatileFilter from './VersatileFilter.vue'

export default {
  components: { VersatileFilter },  // eslint-disable-line
  props: {
    groupId: {
      type: String,
      default: '',
    },
    groupLabel: {
      type: String,
      default: '',
    },
    groupType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      groupFilters: [],
    }
  },
  computed: {
    ...mapState(['searchFilters']),
  },
  mounted() {
    this.getGroupFilters(this.groupId)
  },
  methods: {
    getGroupFilters(groupId) {
      this.groupFilters = this.searchFilters.filterSettings.filter((obj) => {
        return obj.group == groupId
      })
    },
  },
}
</script>
